// @flow
import * as React from 'react';
import styled from 'styled-components';
import { removeKeys } from 'utils/functional';
import { colors, transition, fontWeights } from '../theme';

const StyledDateTime = styled.div`
  & input {
    font: inherit;
    font-size: 18px;
    color: ${colors.charcoalGrey};
    border-radius: 4px;
    border: solid 1px ${colors.silver};
    height: 45px;
    width: 100%;
    margin: 0;
    padding: 11px 1em;
    background-color: ${colors.white};
    background-image: url('/static/images/icons/calendar.svg');
    background-size: 13px 13px;
    background-position: calc(100% - 18px) center;
    background-repeat: no-repeat;
    transition: all ${transition};
    ${props =>
      props.hasError &&
      `
    border-color: ${colors.scarlet};
    box-shadow: 0 0 0 1px ${colors.scarlet};
  `}
    &:focus {
      border-color: ${colors.waterBlue};
      box-shadow: 0 0 0 1px ${colors.waterBlue};
      outline: 0;
    }
    ::placeholder {
      color: ${colors.middleGrey};
    }
  }
  .rdt {
    td,
    th {
      font-size: 14px;
    }
    th {
      font-weight: ${fontWeights.semiBold};
    }
  }
`;

type Props = {
  hasError?: boolean,
  'data-qa-id'?: string
};

type State = {
  dateTimeComponent: React.ComponentType<any>,
  focused: boolean
};

export default class DateTimeLoadable extends React.PureComponent<
  Props,
  State
> {
  state = {
    dateTimeComponent: () => <input readOnly />,
    focused: false
  };

  componentDidMount() {
    import(/* webpackChunkName: "DateTime" */ 'react-datetime').then(object => {
      this.setState({ dateTimeComponent: object.default });
    });
  }

  render() {
    const DateTime = this.state.dateTimeComponent;
    const { hasError, ...props } = this.props;
    const qaId = props['data-qa-id'];
    const passedProps = removeKeys(props, ['data-qa-id']);

    return (
      <StyledDateTime
        data-qa-id={qaId}
        hasError={hasError}
        focused={this.state.focused}
      >
        <DateTime {...passedProps} />
      </StyledDateTime>
    );
  }
}
